/* eslint-disable import/prefer-default-export */
import {
  TravelAnalysisMessages,
  TranslationTravelAnalysisMessages
} from "../interfaces";

export const messages: TranslationTravelAnalysisMessages = {
  [TravelAnalysisMessages.pageTitle]: "Travel Analysis",
  [TravelAnalysisMessages.filterButton]: "Filter",
  [TravelAnalysisMessages.loading]: "Loading...",
  [TravelAnalysisMessages.totalAnalyzed]: "Total Analyzed",
  [TravelAnalysisMessages.successfulTrips]: "Successful Trips",
  [TravelAnalysisMessages.successRate]: "Success Rate",
  [TravelAnalysisMessages.alertsDetected]: "Alerts Detected",
  [TravelAnalysisMessages.target]: "TARGET",
  [TravelAnalysisMessages.alertDistributionTitle]: "Alert Distribution by Type",
  [TravelAnalysisMessages.noAlertsInPeriod]: "No alerts in this period",
  [TravelAnalysisMessages.successRatioTitle]: "Success vs Alerts Ratio",
  [TravelAnalysisMessages.noData]: "No data",
  [TravelAnalysisMessages.success]: "Success",
  [TravelAnalysisMessages.alerts]: "Alerts",
  [TravelAnalysisMessages.efficiency]: "Efficiency",
  [TravelAnalysisMessages.geographicMonitoringTitle]: "Geographic Monitoring",
  [TravelAnalysisMessages.geographicMonitoringSubtitle]: "Alert distribution by operating region",
  [TravelAnalysisMessages.noGeographicData]: "No geographic data",
  [TravelAnalysisMessages.activeVehicles]: "Active Vehicles",
  [TravelAnalysisMessages.activeAlerts]: "Active Alerts",
  [TravelAnalysisMessages.dashboardSubtitle]: "OPERATIONS DASHBOARD",
  [TravelAnalysisMessages.percentOfTotal]: "of total",
  [TravelAnalysisMessages.alertsListTitle]: "Alert Details",
  [TravelAnalysisMessages.columnVehicle]: "Vehicle",
  [TravelAnalysisMessages.columnAlertType]: "Alert Type",
  [TravelAnalysisMessages.columnOrigin]: "Origin",
  [TravelAnalysisMessages.columnDestination]: "Destination",
  [TravelAnalysisMessages.columnDate]: "Date",
  [TravelAnalysisMessages.noAlertsFound]: "No alerts found",
  [TravelAnalysisMessages.loadMore]: "Load more",
  [TravelAnalysisMessages.close]: "Close",
  [TravelAnalysisMessages.tripsUnit]: "trips",
  [TravelAnalysisMessages.columnNumDoc]: "Doc #",
  [TravelAnalysisMessages.columnActions]: "Actions",
  [TravelAnalysisMessages.viewAlertDetails]: "Alert details",
  [TravelAnalysisMessages.viewTravel]: "Open travel",
  [TravelAnalysisMessages.alertDetailsTitle]: "Analysis Details",
  [TravelAnalysisMessages.loadingTravel]: "Loading travel...",
  // Metadata labels — CAN Data Stall
  [TravelAnalysisMessages.metaSource]: "Data source",
  [TravelAnalysisMessages.metaStallType]: "Stall type",
  [TravelAnalysisMessages.metaThreshold]: "Threshold",
  [TravelAnalysisMessages.metaStalledFields]: "Stalled fields",
  [TravelAnalysisMessages.metaTotalCanPackets]: "Total CAN packets",
  // Cross Day Cycle
  [TravelAnalysisMessages.metaStartDate]: "Start date",
  [TravelAnalysisMessages.metaFinishDate]: "Finish date",
  [TravelAnalysisMessages.metaStartDay]: "Start day",
  [TravelAnalysisMessages.metaFinishDay]: "Finish day",
  [TravelAnalysisMessages.metaDurationHours]: "Duration (hours)",
  // False Positive Discharge
  [TravelAnalysisMessages.metaTotalDischargeCommands]: "Total discharge commands",
  [TravelAnalysisMessages.metaCoveredCommands]: "Covered commands",
  [TravelAnalysisMessages.metaOrphanCommands]: "Orphan commands",
  [TravelAnalysisMessages.metaOrphanRatio]: "Orphan ratio (%)",
  [TravelAnalysisMessages.metaCoveredRanges]: "Covered ranges",
  // GPRS Connection Instability
  [TravelAnalysisMessages.metaTotalPackets]: "Total packets",
  [TravelAnalysisMessages.metaMemoryCommands]: "Real offline commands",
  [TravelAnalysisMessages.metaEffectiveRealtimeCommands]: "Effectively realtime commands",
  [TravelAnalysisMessages.metaRealtimeCommands]: "Realtime commands",
  [TravelAnalysisMessages.metaMemoryRatio]: "Real offline ratio (%)",
  [TravelAnalysisMessages.metaThresholdPercent]: "Threshold (%)",
  [TravelAnalysisMessages.metaEffectiveRealtimeThresholdSeconds]: "Effective realtime threshold (s)",
  [TravelAnalysisMessages.metaAvgDelaySeconds]: "Avg transmission delay (s)",
  [TravelAnalysisMessages.metaMaxDelaySeconds]: "Max transmission delay (s)",
  // GPS Positioning Failure
  [TravelAnalysisMessages.metaTotalGpsPackets]: "Total GPS packets",
  [TravelAnalysisMessages.metaInvalidFixCount]: "Invalid positions",
  [TravelAnalysisMessages.metaInvalidRatio]: "Invalid ratio (%)",
  [TravelAnalysisMessages.metaAvgSatellites]: "Average satellites",
  // Hardware Command Deficit
  [TravelAnalysisMessages.metaPacketCount]: "Packets received",
  [TravelAnalysisMessages.metaExpectedPackets]: "Expected packets",
  [TravelAnalysisMessages.metaMinimumRequired]: "Minimum required",
  [TravelAnalysisMessages.metaDeficitPercent]: "Deficit (%)",
  [TravelAnalysisMessages.metaRatePerMinute]: "Rate per minute",
  [TravelAnalysisMessages.metaTravelDurationMinutes]: "Travel duration (min)",
  // Logistics Flow Inconsistency
  [TravelAnalysisMessages.metaRequiredStates]: "Required states",
  [TravelAnalysisMessages.metaActualStates]: "Present states",
  [TravelAnalysisMessages.metaMissingStates]: "Missing states",
  [TravelAnalysisMessages.metaMissingCount]: "Missing count",
  [TravelAnalysisMessages.metaTotalStates]: "Total states",
  [TravelAnalysisMessages.metaNumDoc]: "Doc number",
  // Sensor Command Deficit (IDLE)
  [TravelAnalysisMessages.metaIgnitionOnCount]: "Ignition ON commands",
  [TravelAnalysisMessages.metaIdleCount]: "IDLE commands",
  [TravelAnalysisMessages.metaLoadingCount]: "Loading commands",
  [TravelAnalysisMessages.metaUnloadingCount]: "Unloading commands",
  [TravelAnalysisMessages.metaIdleRatio]: "IDLE ratio (%)",
  [TravelAnalysisMessages.successByDayTitle]: "Success by Day",
  [TravelAnalysisMessages.successByPlantTitle]: "Success by Plant",
  [TravelAnalysisMessages.successByRegionalTitle]: "Success by Regional",
  [TravelAnalysisMessages.averageLine]: "Average",
  [TravelAnalysisMessages.noGroupedData]: "No data for the selected period",
  [TravelAnalysisMessages.coordinateViewTitle]: "Coordinate View",
  [TravelAnalysisMessages.coordinateViewVehicle]: "Vehicle",
  [TravelAnalysisMessages.coordinateViewNF]: "NF",
  [TravelAnalysisMessages.coordinateViewGeneral]: "General",
  [TravelAnalysisMessages.coordinateViewContent]: "Content",
  [TravelAnalysisMessages.coordinateViewResult]: "Result",
  [TravelAnalysisMessages.coordinateViewGeneralData]: "General Data",
  [TravelAnalysisMessages.coordinateViewCommandContent]: "Command Content",
  [TravelAnalysisMessages.coordinateViewProcessingResult]: "Processing Result",
  [TravelAnalysisMessages.coordinateViewNoData]: "No data",
  [TravelAnalysisMessages.coordinateViewField]: "Field",
  [TravelAnalysisMessages.coordinateViewValue]: "Value",
  // Alert glossary (help drawer)
  [TravelAnalysisMessages.glossaryButtonLabel]: "About the alerts",
  [TravelAnalysisMessages.glossaryDrawerTitle]: "Understanding Travel Alerts",
  [TravelAnalysisMessages.glossaryIntroTitle]: "How the analysis works",
  [TravelAnalysisMessages.glossaryIntroText]:
    "The analysis runs automatically as soon as a travel is finished. At that point the travel enters a queue and a background process gathers all of its data — vehicle states, events, coordinates and the raw packets received from the tracker during the travel window — and applies the checks below. Each check that finds an anomaly generates an alert with its details. Travels that generate no alerts are counted as success in the rate shown on the dashboard.",
  [TravelAnalysisMessages.glossaryWhenLabel]: "When it fires",
  [TravelAnalysisMessages.glossaryAppliesLabel]: "Applies to",
  [TravelAnalysisMessages.glossaryMetadataLabel]: "Captured details (metadata)",
  [TravelAnalysisMessages.glossaryAppliesAll]: "All vehicles",
  [TravelAnalysisMessages.glossaryAppliesMixerPump]: "Concrete mixers and pump trucks",
  [TravelAnalysisMessages.glossaryAppliesMixer]: "Concrete mixers",
  [TravelAnalysisMessages.glossaryAppliesMixerDoc]: "Concrete mixers with a Doc number (concrete travel)",
  // Glossary — GPRS Connection Instability
  [TravelAnalysisMessages.glossaryGprsTitle]: "GPRS connection instability",
  [TravelAnalysisMessages.glossaryGprsDesc]:
    "Indicates the tracker lost its data signal (GPRS) during the travel. Packets captured while offline are stored in the device memory and only reach the server once the signal returns, arriving late. A high volume of these late packets suggests poor coverage or a carrier/SIM issue, and may leave gaps in the route.",
  [TravelAnalysisMessages.glossaryGprsWhen]:
    "When 30% or more of the packets arrived late from memory (transmission delay of 60s or more). Memory packets arriving in under 60s are treated as real-time and do not count.",
  [TravelAnalysisMessages.glossaryGprsMeta]:
    "The numbers show how many packets came in real time, how many actually arrived late from memory, and the average and maximum transmission delay — the larger the delay, the worse the signal was.",
  // Glossary — GPS Positioning Failure
  [TravelAnalysisMessages.glossaryGpsTitle]: "GPS positioning failure",
  [TravelAnalysisMessages.glossaryGpsDesc]:
    "Indicates the device could not obtain a reliable satellite position for a large part of the travel. It can be caused by obstruction (tunnels, enclosed areas), an antenna problem or few visible satellites, affecting the accuracy of the recorded route.",
  [TravelAnalysisMessages.glossaryGpsWhen]:
    "When 30% or more of the packets with GPS data had no valid satellite fix (invalid FIX).",
  [TravelAnalysisMessages.glossaryGpsMeta]:
    "Show the total GPS packets, how many had no fix and the average number of satellites captured — low averages reinforce reception difficulty.",
  // Glossary — Cross Day Cycle
  [TravelAnalysisMessages.glossaryCrossDayTitle]: "Cross-day cycle (D+1)",
  [TravelAnalysisMessages.glossaryCrossDayDesc]:
    "Flags travels that started on one day and only finished on the next. Crossing into a new day impacts the daily productivity closing, since the travel appears on two different days.",
  [TravelAnalysisMessages.glossaryCrossDayWhen]:
    "When the start day differs from the finish day and the travel lasted 6 hours or more (short travels that merely cross midnight are ignored).",
  [TravelAnalysisMessages.glossaryCrossDayMeta]:
    "Show the start and finish dates and days, plus the total travel duration in hours.",
  // Glossary — Hardware Command Deficit
  [TravelAnalysisMessages.glossaryHwDeficitTitle]: "Hardware command deficit",
  [TravelAnalysisMessages.glossaryHwDeficitDesc]:
    "Indicates the tracker transmitted fewer packets than expected for the travel duration. It may signal a faulty device, one turned off part of the time, or a transmission problem, reducing the reliability of the travel data.",
  [TravelAnalysisMessages.glossaryHwDeficitWhen]:
    "When the number of received packets fell below 50% of the expected (baseline of 1 packet every 2 minutes). Evaluated only on travels longer than 5 minutes.",
  [TravelAnalysisMessages.glossaryHwDeficitMeta]:
    "Compare received packets with expected ones and show the percentage deficit and the packets-per-minute rate.",
  // Glossary — Sensor Command Deficit (IDLE)
  [TravelAnalysisMessages.glossarySensorIdleTitle]: "Active sensor command deficit (high IDLE)",
  [TravelAnalysisMessages.glossarySensorIdleDesc]:
    "Indicates that, with the vehicle running, the drum stayed idle — neither loading nor unloading — for a large part of the travel. It may point to a faulty drum sensor or a communication problem, hurting the reading of the loading and unloading stages.",
  [TravelAnalysisMessages.glossarySensorIdleWhen]:
    "When, among the packets with ignition on, 50% or more had the drum idle (IDLE). Evaluated with at least 10 ignition-on packets.",
  [TravelAnalysisMessages.glossarySensorIdleMeta]:
    "Show how many packets had ignition on and, of those, how many were loading, unloading or idle (IDLE).",
  // Glossary — Logistics Flow Inconsistency
  [TravelAnalysisMessages.glossaryLogisticsTitle]: "Logistics flow inconsistency",
  [TravelAnalysisMessages.glossaryLogisticsDesc]:
    "Flags concrete travels that did not go through all the expected cycle states (At the plant → On the way → At construction site → Unloading → Returning). A missing state may indicate a detection failure, an atypical route or a travel logging issue.",
  [TravelAnalysisMessages.glossaryLogisticsWhen]:
    "When at least one of the required states is missing. It checks the presence of each state, not the order.",
  [TravelAnalysisMessages.glossaryLogisticsMeta]:
    "List the required states, the ones that occurred and the ones missing from the travel.",
  // Glossary — CAN Data Stall
  [TravelAnalysisMessages.glossaryCanStallTitle]: "Stalled CAN data (full or partial)",
  [TravelAnalysisMessages.glossaryCanStallDesc]:
    "Indicates that data coming from the vehicle's CAN bus (speed, RPM, fuel, odometer) became 'frozen', repeating the same value across several consecutive packets. It usually points to a CAN reading failure, hurting the vehicle telemetry.",
  [TravelAnalysisMessages.glossaryCanStallWhen]:
    "When a CAN field repeats the same value across 10 consecutive packets or more. 'Total' = all fields frozen; 'Partial' = at least one field frozen.",
  [TravelAnalysisMessages.glossaryCanStallMeta]:
    "Show which fields stalled, for how many consecutive packets and the value that stayed repeated.",
  // Glossary — False Positive Discharge
  [TravelAnalysisMessages.glossaryFalseDischargeTitle]: "False discharge positives",
  [TravelAnalysisMessages.glossaryFalseDischargeDesc]:
    "Flags drum discharge commands that occurred outside any valid unloading context (not while unloading, at the plant, in a trusted location or during an improper-discharge event). These 'orphan' commands may be sensor noise or discharges not detected correctly.",
  [TravelAnalysisMessages.glossaryFalseDischargeWhen]:
    "When there are 3 or more orphan discharge commands (not covered by any known discharge period).",
  [TravelAnalysisMessages.glossaryFalseDischargeMeta]:
    "Show the total discharge commands, how many were covered by a valid context and how many were left orphan."
};
